export default __webpack_public_path__ + "static/media/UpSkillBanner.41e4f01d.webp";